/* eslint-disable import/prefer-default-export */
export var getDynamicStyle = function getDynamicStyle(gradientColor, initialHeight) {
  return {
    $$fadeToColor: "$colors".concat(gradientColor),
    $$initialHeight: initialHeight
  };
};